module.exports = __webpack_public_path__ + "static/media/map.61004589.png";